import { saveUser, clearUser, saveCollege, clearCollege, saveHistorySearch, clearHistorySearch } from '../common/js/cache'
import * as types from './mutation-types'


export const saveUserAction = function({commit}, query){
	commit(types.SET_USER, saveUser(query))
}

export const clearUserAction = function({commit}){
	commit(types.SET_USER, clearUser())
  commit(types.CLEAR_USER)
}

export const saveCollegeAction = function({commit}, query){
	commit(types.SET_COLLEGE, saveCollege(query))
}

export const clearCollegeAction = function({commit}){
	commit(types.SET_COLLEGE, clearCollege())
}

export const saveHistorySearchAction = function({commit}, query){
	console.log(query)
	commit(types.SET_HISTORY_SEARCH, saveHistorySearch(query))
}

export const clearHistorySearchAction = function({commit}){
	commit(types.SET_HISTORY_SEARCH, clearHistorySearch())
}


// WEBPACK FOOTER //
// ./src/store/actions.js